export default __webpack_public_path__ + "locales/fr/Payments.json?hash=3c3b97c9e934b575e030a594facf1448";